"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _Reply = _interopRequireDefault(require("@material-ui/icons/Reply"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _UserIcon = _interopRequireDefault(require("../User/UserIcon"));

var _ModuleLabel = _interopRequireDefault(require("../Module/ModuleLabel"));

var _ModuleDate = _interopRequireDefault(require("../Module/ModuleDate"));

var _getInboxMessage2 = _interopRequireDefault(require("./utils/getInboxMessage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "block",
    width: "100%",
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(2),
    userSelect: "none",
    "&[data-unread=true]": {
      "& $name": {
        fontWeight: "bold"
      }
    }
  },
  avatar: {
    position: "absolute",
    top: 0,
    left: 0,
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2)
  },
  reply: {
    paddingLeft: theme.spacing(9),
    paddingRight: theme.spacing(2)
  },
  author: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    display: "flex",
    alignItems: "baseline"
  },
  metadata: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    //        lineHeight: "24px",
    display: "flex",
    //        alignItems: "center",
    "& > * + *": {
      marginLeft: theme.spacing(.5)
    }
  },
  icon: {
    fontSize: "18px",
    marginRight: theme.spacing(0.5)
  },
  name: {
    "& + $datetime": {
      marginLeft: '.5em'
    },
    "& + $email": {
      marginLeft: '.5em'
    }
  },
  datetime: {
    fontSize: "14px",
    opacity: 0.85
  },
  email: {
    fontSize: "14px",
    opacity: 0.85
  }
}));

const InboxMessageHeader = (_ref) => {
  let expanded = _ref.expanded,
      unread = _ref.unread,
      replyTo = _ref.replyTo,
      onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["expanded", "unread", "replyTo", "onClick"]);

  const _getInboxMessage = (0, _getInboxMessage2.default)(props),
        label = _getInboxMessage.label,
        labelColor = _getInboxMessage.labelColor,
        status = _getInboxMessage.status,
        author = _getInboxMessage.author,
        datetime = _getInboxMessage.datetime;

  const classes = useStyles();

  if (replyTo) {
    return _react.default.createElement("header", {
      className: classes.root,
      onClick: onClick,
      "data-unread": unread,
      "data-status": status
    }, _react.default.createElement(_UserIcon.default, _extends({}, author, {
      className: classes.avatar
    })), _react.default.createElement(_Typography.default, {
      className: classes.metadata
    }, _react.default.createElement(_Reply.default, {
      className: classes.icon
    }), _react.default.createElement("i", {
      className: classes.recipient
    }, "to ", replyTo)));
  }

  if (expanded) {
    return _react.default.createElement("header", {
      className: classes.root,
      onClick: onClick,
      "data-unread": unread,
      "data-status": status
    }, _react.default.createElement(_UserIcon.default, _extends({}, author, {
      className: classes.avatar
    })), _react.default.createElement(_Typography.default, {
      className: classes.author
    }, _react.default.createElement("b", {
      className: classes.name
    }, author && author.name), _react.default.createElement("i", {
      className: classes.email
    }, author && author.email)), _react.default.createElement("div", {
      className: classes.metadata
    }, _react.default.createElement(_ModuleLabel.default, {
      label: label,
      labelColor: labelColor
    }), _react.default.createElement(_ModuleDate.default, {
      className: classes.datetime,
      datetime: datetime
    })));
  }

  return _react.default.createElement("header", {
    className: classes.root,
    onClick: onClick,
    "data-unread": unread,
    "data-status": status
  }, _react.default.createElement(_UserIcon.default, _extends({}, author, {
    className: classes.avatar
  })), _react.default.createElement(_Typography.default, {
    className: classes.author
  }, _react.default.createElement("b", {
    className: classes.name
  }, author && author.name), _react.default.createElement(_ModuleDate.default, {
    className: classes.datetime,
    datetime: datetime
  })));
};

var _default = InboxMessageHeader;
exports.default = _default;
module.exports = exports.default;